import axios from "axios";
import { MAIN_URL } from "../Configurations/Urls";
import toast from "react-hot-toast";

export async function fetchClientLicenses() {
  try {
    const response = await axios.get(
      `${MAIN_URL}/api/client-management/client-licenses`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    if (error.response) {
      console.error("API Response Error:", error.response.data);
      throw new Error(error.response.data.error || "Failed to fetch profile");
    } else if (error.request) {
      console.error("No Response Received:", error.request);
      throw new Error("No response from server.");
    } else {
      console.error("Error:", error.message);
      throw new Error("An unexpected error occurred.");
    }
  }
}




export async function fetchOrganizationClientsSpecial() {
    try {
      const response = await axios.get(
        `${MAIN_URL}/api/client-management/organization-clients`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("API Response Error:", error.response.data);
        throw new Error(error.response.data.error || "Failed to fetch profile");
      } else if (error.request) {
        console.error("No Response Received:", error.request);
        throw new Error("No response from server.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred.");
      }
    }
  }





  export async function fetchOrganizationClientContactsSpecial() {
    try {
      const response = await axios.get(
        `${MAIN_URL}/api/client-management/client-contacts`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("API Response Error:", error.response.data);
        throw new Error(error.response.data.error || "Failed to fetch profile");
      } else if (error.request) {
        console.error("No Response Received:", error.request);
        throw new Error("No response from server.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred.");
      }
    }
  }




  export async function fetchClientPaymentsSpecial() {
    try {
      const response = await axios.get(
        `${MAIN_URL}/api/client-management/client-payments`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("API Response Error:", error.response.data);
        throw new Error(error.response.data.error || "Failed to fetch profile");
      } else if (error.request) {
        console.error("No Response Received:", error.request);
        throw new Error("No response from server.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred.");
      }
    }
  }




  export async function fetchClientOrganizationsSpecial() {
    try {
      const response = await axios.get(
        `${MAIN_URL}/api/client-management/organizations`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      if (error.response) {
        console.error("API Response Error:", error.response.data);
        throw new Error(error.response.data.error || "Failed to fetch profile");
      } else if (error.request) {
        console.error("No Response Received:", error.request);
        throw new Error("No response from server.");
      } else {
        console.error("Error:", error.message);
        throw new Error("An unexpected error occurred.");
      }
    }
  }
